import React from 'react'
import styled from '@emotion/styled'

export const DogColour: React.FC<{ acceptorNumber: number }> = ({ acceptorNumber }) => (
  <svg viewBox='0 0 100 100' data-tid-dog-colour-number={acceptorNumber}>
    <DogColourGroup acceptorNumber={acceptorNumber} border />
  </svg>
)

const dogSilkRectangles: Record<number, number> = {
  1: 0,
  2: 4,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 4,
  10: 3,
}

export const DogColourGroup: React.FC<{
  acceptorNumber: number
  border: boolean
}> = ({ acceptorNumber, border }) => {
  const numRectangles = dogSilkRectangles[acceptorNumber]
  const dogBoxClass = border ? 'dogboxstroked' : 'dogbox'
  const dogNumberClass = `dogbox-${acceptorNumber}`
  const dogTextClass = `dogboxtext-${acceptorNumber}`

  return (
    <DogColourStyled>
      <rect width='100' height='100' className={`${dogBoxClass} ${dogNumberClass}`} />
      {Array(numRectangles)
        .fill(0)
        .map((_, i) => {
          const dogRectClass = `dogbox-${acceptorNumber}-${i + 1}`
          return (
            dogRectClass && (
              <rect
                key={i}
                width='100'
                height={100 / numRectangles}
                y={(100 / numRectangles) * i}
                className={dogRectClass}
              />
            )
          )
        })}
      <text textAnchor='middle' x='50' y='75' className={`dogboxtext ${dogTextClass}`}>
        {acceptorNumber}
      </text>
    </DogColourStyled>
  )
}

// ======
// Styles
// ======

const DogColourStyled = styled.g({
  '.dogboxtext': {
    fontSize: 65,
    fontWeight: 'bold',
    fill: '#fff',
  },

  '.dogbox': { strokeWidth: 0 },
  '.dogboxstroked': { strokeWidth: 5 },

  '.dogbox-1': { fill: '#f00', stroke: '#7b0100' },

  '.dogbox-2-2, .dogbox-2-4': { fill: ' #fff' },
  '.dogbox-2': { fill: '#000', stroke: '#000' },
  '.dogboxtext-2': { stroke: '#000', strokeWidth: 3 },

  '.dogbox-3': { fill: '#fff', stroke: '#999' },
  '.dogboxtext-3': { fill: '#000' },

  '.dogbox-4': { fill: '#1c96f4', stroke: '#111' },

  '.dogbox-5': { fill: '#f4f11c', stroke: '#74720e' },
  '.dogboxtext-5': { fill: '#000' },

  '.dogbox-6': { fill: '#2d7e33', stroke: '#173c1a' },

  '.dogbox-7': { fill: '#222', stroke: '#000' },
  '.dogboxtext-7': { fill: '#f4f11c' },

  '.dogbox-8': {
    fill: '#d738d1',
    stroke: '#661b63',
    textShadow: 'none',
  },

  '.dogbox-9': { fill: '#fff', stroke: '#000' },
  '.dogbox-9-1, .dogbox-9-3': { fill: '#35833b' },
  '.dogboxtext-9': { stroke: '#000', strokeWidth: 3 },

  '.dogbox-10': { stroke: '#000', fill: 'rgb(3, 2, 2)' },
  '.dogbox-10-1': { fill: '#280eae' },
  '.dogbox-10-2': { fill: '#cb0a0a' },
  '.dogboxtext-10': { stroke: '#000', strokeWidth: 3 },
})
